"use client";

import Link from "next/link";

import { LANDING_PAGE_PATH } from "@/lib/landing-page";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <div className="flex flex-grow flex-col items-center justify-center px-4 text-center">
        <h1 className="mb-4 text-4xl font-bold">Page Not Found</h1>
        <p className="mb-8 text-gray-600">
          The page you&#39;re looking for doesn&#39;t exist or has been moved.
        </p>
        <Link
          href={LANDING_PAGE_PATH}
          className="rounded-full bg-indigo-600 px-8 py-3 font-medium text-white transition-colors hover:bg-indigo-700"
        >
          Back to Shopping
        </Link>
      </div>
    </div>
  );
}
